export function useVerifyServer(server) {
  switch (server) {
    case "globalbrl":
    case "globalusd":
    case "seasonusd":
    case "seasonbrl":
    case "test":
      return "global";
    default:
      return server;
  }
}